import type { IconSvgObject } from './types';

const MetaIcon: IconSvgObject = [
  ["path", { d: "M12 9.86967C10.0377 6.62167 8.31651 5 6.83534 5C4.61303 5 3.20964 7.58183 2.39071 11.0865C1.60846 14.4337 1.83513 19 4.61303 19C5.85086 19 7.55537 17.1742 9.22211 14.7393C10.3333 13.1165 11.2589 11.4925 12 9.86967ZM12 9.86967C13.9623 6.62167 15.6835 5 17.1647 5C19.387 5 20.7904 7.58183 21.6093 11.0865C22.3915 14.4337 22.1649 19 19.387 19C18.1491 19 16.4446 17.1742 14.7779 14.7393C13.6667 13.1165 12.7411 11.4925 12 9.86967Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default MetaIcon;
